// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__wDFU_","signatureButtonsRight":"ModalSign_signatureButtonsRight__337yH"};